export const Method = Object.freeze({
    OFFLINE: Symbol("method"),
    ONLINE: Symbol("method")
})

export const Status = Object.freeze({
    RUNNING: Symbol("status"),
    OVER: Symbol("status"),
    SEARCHING: Symbol("status")
})

export const StatusMessage = Object.freeze({
    [Status.RUNNING]: (cur, _) => `${cur} turn`,
    [Status.OVER]: (cur, additional) => <>{cur} won! {additional}</>,
    [Status.SEARCHING]: (_, __) => `Waiting for a challenger to join!`
})

export const Online = Object.freeze({
    AVAILABLE: Symbol("online_status"),
    LOADING: Symbol("online_status"),
    UNAVAILABLE: Symbol("online_status")
})
